import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private authService: AuthService,
    private title: Title,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.title.setTitle('Rondeivu | Multifactor Authentication');

    var userEmail = this.authService.getUserEmail();
    if (!userEmail) {
      console.error("No user email found for forced password reset");
      this.toastrService.error('No user email found for password reset. Please log in again.', 'Error');
      this.authService.navigateToLogin();
      return;
    }
  }

  resendSMS() {
    console.log("Resending SMS code");
    

    this.authService.ResendMFACode().subscribe(res => {
      console.log("Resend MFA code response", res);
    });
  }

  confirmSMS(event: any) {
    console.log("Confirming SMS code", event);
    this.authService.ConfirmMFA(event).subscribe(console.log)
  }
}
